export default {
  VARIABLES_LOADING_IN_PROCESS: 'VARIABLES_LOADING_IN_PROCESS',
  VARIABLES_LOADING_SUCCESS: 'VARIABLES_LOADING_SUCCESS',
  VARIABLES_LOADING_FAILED: 'VARIABLES_LOADING_FAILED',
};
